import { useProductAPI } from "../product/useProductAPI";
import { usePartnerAPI } from "../partner/usePartnerAPI";
import { useProcessAPI } from "../process/useProcessAPI";
import { useMachineAPI } from "../machine/useMachineAPI";
import { useContractAPI } from "../contract/useContractAPI";
import { useMaterialAPI } from "../material/useMaterialAPI"
import { useUserAPI } from "../user/useUserAPI";
import { use } from "react";

export const useApiSelect = () => {
    
    const productAPI = useProductAPI();
    const partnerAPI = usePartnerAPI();
    const processAPI = useProcessAPI();
    const machineAPI = useMachineAPI();
    const contractAPI = useContractAPI();
    const materialAPI = useMaterialAPI();
    const userAPI = useUserAPI();

    const request = { 
        product: async (params) => {
            const res = await productAPI.product.findByCompanySeq(params);
            return (res || []).map(product => ({
                productSeq: product.productSeq,
                productName: product.productName
            }));
        },
        partner: async (params) => {
            const res = await partnerAPI.partner.get(params);
            const data = (res?.list || []).map((partner) => ({
                partnerSeq: partner.partnerSeq,
                partnerName: partner.partnerName
            }));
            return data;
        },
        process: async (params) => {
            const res = await processAPI.process.selector(params);
            const data = (res || []).map((process) => ({
                processSeq: process.processSeq,
                processName: process.processName
            }));
            return data;
        },
        machine: async (params) => {
            const res = await machineAPI.machine.get(params);
            const data = (res?.list || []).map((machine) => ({
                machineSeq: machine.machineSeq,
                machineName: machine.machineName
            }));
            return data;
        },
        contract:async (params) => {
            const res = await contractAPI.contract.get(params);
            const data = (res?.list || []).map((contract) => ({
                contractSeq: contract.contractSeq,
                contractNum: contract.contractNum
            }));
            return data;
        },
        material:async (params) => {
            const res = await materialAPI.material.get(params);
            const data = (res?.list || []).map((material) => ({
                materialSeq: material.materialSeq,
                materialName: material.materialName
            }));
            return data;
        },
        user: async (params) => {
            const res = await userAPI.user.findByCompanySeq(params);
            const data = (res || []).map((user) => ({
                userSeq: user.userSeq,
                userName: user.name
            }));
            return data;
        },
    }

    return { request };
}